export default (inputString: string) => inputString.replace(/([a-z])([A-Z])/g, (match, p1, p2) => p1 + ' ' + p2);

export const sentenceCase = (inputString: string) => inputString.replace(/([a-z])([A-Z])/g, (match, p1, p2) => p1 + ' ' + p2.toLowerCase());
